__turbopack_context__.v({
  "button": "AccessibleTooltip-module__idRFjG__button",
  "tooltipTarget": "AccessibleTooltip-module__idRFjG__tooltipTarget",
});
